import './ProjectItemViewComponent.scss';
import React, { useEffect, useState } from 'react';
import { DataRequestProject } from '../../../../models/DataRequestHub/DataRequestProject';
import { QuestionnaireModuleHost } from '../../../DataRequest/DataRequestDashboardPage/QuestionnaireModuleHost/QuestionnaireModuleHost';
import { DataForm } from '../../../../models/DataRequestHub/DataForm';
import { useStateSelector } from '../../../../store/selectors';
import { useCurrentMarketplaceParty } from '../../../../custom-hooks/useCurrentMarketplaceParty';
import { TimelineParty } from '../../../../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { EngagementDocument } from '../../../../slices/marketplace/timeline/models/engagement-document';

interface ProjectItemViewComponentProps {
    project: DataRequestProject;
    isReadonlyMode: boolean;
    questionnaireDocument: EngagementDocument;
}

const ProjectItemViewComponent = (props: ProjectItemViewComponentProps) => {
    const axios = useStateSelector((s) => s.core.axios);
    const [form, setForm] = useState<DataForm>();
    const questionsSeenStatus = useStateSelector(
        (s) => s.dataRequestsNotifications.questionsSeenStatus
    );
    const party = useCurrentMarketplaceParty();

    useEffect(() => {
        setForm({
            ...props.project.dataForms.find(
                (d) => d.id === props.questionnaireDocument.questionnaireId
            ),
        });
    }, []);

    const markQuestionsAsSeen = (
        formId: number,
        questionsIds: number[],
        subQuesitonsIds: number[]
    ) => {
        const putObject = {
            questionsIds: questionsIds,
            subQuesitonsIds: subQuesitonsIds,
        };

        const targetForm = props.project.dataForms.find((f) => f.id === formId);

        if (
            (!props.project.isSeenByUser || targetForm.isNew) &&
            party === TimelineParty.Seller
        ) {
            axios.put(
                `/api/DataRequestProjects/${props.project.id}/dataForm/${formId}/seenFlag`
            );
        } else {
            axios.put(
                `/api/DataRequestProject/${props.project.id}/dataForm/${formId}/questions/seenFlag`,
                putObject
            );
        }
    };

    return !form ? (
        <></>
    ) : (
        <QuestionnaireModuleHost
            key={'questionnaire-view-form'}
            isAdminView={false}
            projectId={props.project.id}
            questionnaireForm={form}
            updateProjectsData={() => {}}
            projectVariables={props.project.variables}
            markQuestionsAsSeen={markQuestionsAsSeen}
            questionsSeenStatus={questionsSeenStatus}
            project={props.project}
            onlyShowQuestionColumns={true}
            isReadonlyMode={props.isReadonlyMode}
        />
    );
};

export default ProjectItemViewComponent;
